import { CIRCLES_API } from "../../config";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";
import fetchRetry from "../fetch_retry";


export function fetchRentableCircles() {
  return function (dispatch, getState) {

    dispatch(ActionCreators.fetchingRentableCircles());
    let url = `${CIRCLES_API}/circle/rentable-circles`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
    };

    return (
      fetchRetry(url, request_options, dispatch, getState) //test
        // return fetch(url, request_options)
        .then(
          (response) => response.json(),
          (error) => {
            dispatch(ActionCreators.errorFetchingRentableCircles(error));
          }
        )
        .then((response) => {
          if ("message" in response || "errors" in response) {
            dispatch(ActionCreators.errorFetchingRentableCircles(response.message));
            dispatch(pushNotification("errors.my_circles.fetch", "error"));
          } else {
            dispatch(ActionCreators.fetchedRentableCircles(response));
          }
        })
    );
  };
}
